/* Membership-only presentation adapter for Shopify Subscriptions' generic
 * physical-delivery copy. Never changes form controls, plan data or consent. */
(() => {
  const script = document.currentScript;
  const root = script?.closest('product-info');
  if (!root || root.dataset.membershipCopyReady) return;
  root.dataset.membershipCopyReady = 'true';
  const translations = new Map([
    ['Zustellung jeden Monat', 'Monatliche Abrechnung'],
    ['Deliver every month', 'Monatliche Abrechnung'],
    ['Automatische Verlängerung, jederzeit überspringen oder kündigen.',
      'Automatische Verlängerung. Kündigungsanfragen stellst du im Kundenkonto; FunnyHooks bearbeitet sie manuell.'],
    ['Auto-renews, skip or cancel anytime.',
      'Automatically renews. Request cancellation in your customer account; FunnyHooks processes it manually.'],
  ]);
  function update() {
    root.querySelectorAll('.shopify_subscriptions_fieldset').forEach(fieldset => {
      const walker = document.createTreeWalker(fieldset, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const original = node.nodeValue.trim();
        const replacement = translations.get(original);
        if (replacement) node.nodeValue = node.nodeValue.replace(original, replacement);
      }
    });
  }
  update();
  new MutationObserver(update).observe(root, { childList: true, subtree: true });
})();
